import { CONSORS_HOUSING_SITUATIONS } from 'cpool-constants';
import { z } from 'zod';

export const schemaConsorsHousingSituation = z.nativeEnum(CONSORS_HOUSING_SITUATIONS);
export type SchemaConsorsHousingSituation = z.infer<typeof schemaConsorsHousingSituation>;
